// Демо-данные окон «AI Assist» и «AI Knowledge Sources» для главной Hub.
// AI Assist отвечает на основе источников знаний и шаблонов; персону можно менять,
// а источники знаний добавлять документами, ссылками и текстами-инструкциями.
import { t } from "@/lib/i18n";

export type AiNavItem = { id: string; label: string; icon: string; badge?: string };
export type AiNavGroup = { group: string; items: AiNavItem[] };

export const aiNav: AiNavGroup[] = [
  {
    group: t("Рабочее пространство"),
    items: [
      { id: "dashboard", label: t("Дашборд"), icon: "ri-dashboard-line" },
      { id: "general", label: t("Общие сведения"), icon: "ri-information-line" },
      { id: "user-settings", label: t("Настройки пользователей"), icon: "ri-user-settings-line" },
      { id: "team-settings", label: t("Настройки команды"), icon: "ri-team-line" },
      { id: "onboarding", label: t("Начало работы"), icon: "ri-flag-2-line", badge: t("Старт") },
      { id: "apps", label: t("Приложения"), icon: "ri-apps-line" },
      { id: "channels", label: t("Каналы"), icon: "ri-share-forward-line" },
      { id: "integrations", label: t("Интеграции"), icon: "ri-links-line" },
      { id: "widgets", label: t("Виджеты"), icon: "ri-layout-grid-line" },
    ],
  },
  {
    group: t("Настройки входящих"),
    items: [
      { id: "contact-fields", label: t("Поля контактов"), icon: "ri-contacts-book-2-line" },
      { id: "lifecycle", label: t("Жизненный цикл"), icon: "ri-refresh-line" },
      { id: "conversations", label: t("Диалоги"), icon: "ri-chat-3-line" },
      { id: "snippets", label: t("Шаблоны"), icon: "ri-file-copy-2-line" },
      { id: "tags", label: t("Теги"), icon: "ri-price-tag-3-line" },
      { id: "ai-assist", label: "AI Assist", icon: "ri-sparkling-line" },
      { id: "ai-prompts", label: "AI Prompts", icon: "ri-question-answer-line" },
      { id: "calls", label: t("Звонки"), icon: "ri-phone-line", badge: t("Новое") },
    ],
  },
  {
    group: t("Данные"),
    items: [
      { id: "files", label: t("Файлы"), icon: "ri-folder-line" },
      { id: "import", label: t("Импорт контактов"), icon: "ri-upload-cloud-2-line" },
      { id: "data-export", label: t("Экспорт данных"), icon: "ri-download-cloud-2-line" },
    ],
  },
];

// разделы, до которых в макете реально можно доскроллить
export const aiNavAnchors: Record<string, string> = {
  dashboard: "#dashboard",
  general: "#general-settings",
  "contact-fields": "#fields",
  lifecycle: "#lifecycle",
  conversations: "#conversations",
  snippets: "#snippets",
  tags: "#tags",
  "ai-assist": "#ai-assist",
  "ai-prompts": "#ai-prompts",
  "ai-knowledge": "#ai-knowledge",
  channels: "#channels",
  widgets: "#widgets",
  calls: "#catalog",
  import: "#contacts-import",
  "data-export": "#data-export",
  "user-settings": "#user-settings",
  onboarding: "#onboarding",
  "team-settings": "#team-settings",
};

export const defaultPersona =
  t("Вы — опытный агент поддержки Hub. Отвечайте коротко, вежливо и только по делу, опираясь на источники знаний и шаблоны ответов. Всегда проверяйте точность ответа перед отправкой и не придумывайте цены, сроки и условия, которых нет в источниках.");

// типы источников знаний
export const knowledgeKinds = [
  { id: "document", label: t("Документ"), icon: "ri-file-text-line", hint: t("PDF, DOCX или TXT до 20 МБ") },
  { id: "link", label: t("Ссылка"), icon: "ri-link", hint: t("Страница сайта, база знаний или Notion") },
  { id: "guide", label: t("Текст-инструкция"), icon: "ri-quill-pen-line", hint: t("Скрипт или правило, вставленное вручную") },
  { id: "api", label: "API", icon: "ri-cloud-line", hint: t("REST API: адрес эндпоинта, токен доступа и автообновление") },
];

// что обычно загружают — подсказки в пустом состоянии
export const knowledgeTips = [
  {
    icon: "ri-file-text-line",
    title: t("Документы"),
    text: t("Прайсы, регламенты и инструкции в PDF, DOCX или TXT — до 20 МБ на файл."),
  },
  {
    icon: "ri-link",
    title: t("Ссылки"),
    text: t("Страницы сайта, база знаний или Notion: ассистент прочитает их и перескажет клиенту."),
  },
  {
    icon: "ri-quill-pen-line",
    title: t("Тексты"),
    text: t("Скрипты и правила, вставленные вручную — когда готового документа ещё нет."),
  },
  {
    icon: "ri-cloud-line",
    title: "API",
    text: t("Подключите свой сервис по адресу и токену — база знаний будет обновляться сама."),
  },
];